import React from "react";
import { Outlet } from "react-router-dom";
import AdminLayout from "./AdminLayout";

// import { DefaultLayout } from "@/layouts";

function Dashboard() {
  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  );
}

export default Dashboard;
